import axios from "@/api/axios";

const getPlatforms = (data) => {
    return axios
        .post('/admin/advertising/get-platforms', {advertising: data})
        .then(response => response.data)
}

const getSources = (data) => {
    return axios
        .post('/admin/advertising/get-sources', {advertising: data})
        .then(response => response.data)
}

export default {
    getPlatforms,
    getSources
}